module.exports = __webpack_public_path__ + "media/images/logo_text-8dad82e22e494cd073c9840379456ed9.svg";